import React from 'react';
import { 
  BuildingOfficeIcon,
  PhoneIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  CurrencyEuroIcon,
} from '@heroicons/react/24/outline';

export const Credits: React.FC = () => {
  return (
    <div className="space-y-8">
      {/* Disclaimer */}
      <div className="card bg-yellow-50 border-yellow-200">
        <div className="flex items-start space-x-3">
          <div className="w-6 h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <span className="text-yellow-600 text-sm">⚠️</span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-yellow-800 mb-2">Disclaimer</h3>
            <div className="text-sm text-yellow-700 space-y-2">
              <p>
                <strong>Attenzione:</strong> I quiz presenti in questa applicazione sono forniti a scopo informativo e di preparazione generale. 
                Nonostante gli sforzi per garantire l'accuratezza dei contenuti, potrebbero essere presenti errori, imprecisioni o informazioni non aggiornate.
              </p>
              <p>
                <strong>Nessuna responsabilità:</strong> Né Live Concorsi, né D-Serviceitalia srl, né alcun altro soggetto coinvolto nello sviluppo 
                di questa applicazione può essere ritenuto responsabile per eventuali errori, imprecisioni o conseguenze derivanti dall'utilizzo 
                dei quiz presenti.
              </p>
              <p>
                <strong>Utilizzo a proprio rischio:</strong> L'utente si assume la piena responsabilità dell'utilizzo di questa applicazione 
                e riconosce che nessun soggetto è perseguibile per legge per eventuali danni diretti o indiretti derivanti dall'uso dei contenuti.
              </p>
              <p>
                Si raccomanda di verificare sempre le informazioni con fonti ufficiali e aggiornate prima di utilizzarle per scopi decisionali importanti.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* D-Service Italia */}
      <div className="card">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-16 h-16 flex items-center justify-center">
            <img 
              src="/Logo-D-Service-1024x847.png" 
              alt="D-Service Italia Logo" 
              className="h-12 w-12 object-contain"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-blue-600">D-Service Italia</h2>
            <p className="text-gray-600">Sviluppo Software & Consulenza IT</p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Informazioni Aziendali */}
          <div>
            <h3 className="text-lg font-bold text-blue-600 mb-4">Informazioni Aziendali</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <BuildingOfficeIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">Partita IVA: 02520560810</span>
              </div>
              <div className="flex items-center space-x-3">
                <CurrencyEuroIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">Capitale Sociale: 60.000 € i.v.</span>
              </div>
            </div>
          </div>
          
          {/* Contatti */}
          <div>
            <h3 className="text-lg font-bold text-blue-600 mb-4">Contatti</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <PhoneIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">Telefono: +39 091 929 5736</span>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">Email: info@d-serviceitalia.it</span>
              </div>
              <div className="flex items-center space-x-3">
                <EnvelopeIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">PEC: info@pec.d-serviceitalia.it</span>
              </div>
              <div className="flex items-center space-x-3">
                <GlobeAltIcon className="h-5 w-5 text-gray-600" />
                <span className="text-gray-700">
                  Sito Web: 
                  <a 
                    href="https://www.d-serviceitalia.it" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline ml-1"
                  >
                    www.d-serviceitalia.it
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Live Concorsi */}
      <div className="card">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-16 h-16 flex items-center justify-center">
            <img 
              src="/logo-live-concorsi.png" 
              alt="Live Concorsi Logo" 
              className="h-12 w-12 object-contain"
            />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-green-600">Live Concorsi</h2>
            <p className="text-gray-600">Committente dell'applicazione</p>
          </div>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-700 leading-relaxed">
            Questa applicazione è stata sviluppata per conto di <strong>Live Concorsi</strong>, 
            una piattaforma che si impegna a tenere sempre informati sulle migliori 
            opportunità lavorative, guidando con risorse pratiche e una visione chiara 
            per il futuro professionale.
          </p>
        </div>
        
        <div className="mb-6">
          <h3 className="text-lg font-bold text-green-600 mb-3">Servizi Offerti</h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Guide dettagliate</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Consigli pratici</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Ultime notizie</span>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Opportunità lavorative</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Materiali per la preparazione</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-gray-700">Community esclusiva</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Tags */}
        <div className="flex flex-wrap gap-3">
          <span className="px-3 py-2 bg-green-100 text-green-800 rounded-lg text-sm font-medium">
            Concorsi Pubblici
          </span>
          <span className="px-3 py-2 bg-green-100 text-green-800 rounded-lg text-sm font-medium">
            Preparazione Esami
          </span>
          <span className="px-3 py-2 bg-green-100 text-green-800 rounded-lg text-sm font-medium">
            Opportunità Lavorative
          </span>
        </div>
        
        <div className="mt-4">
          <div className="flex items-center space-x-2">
            <GlobeAltIcon className="h-5 w-5 text-green-600" />
            <span className="text-gray-700">
              Sito Web: 
              <a 
                href="https://www.liveconcorsi.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-800 underline ml-1"
              >
                www.liveconcorsi.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
